import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["company"]

  connect() { this.update() }

  update() {
    const company = this.element.querySelector("#user_account_type").value === "company"
    this.companyTarget.hidden = !company
    this.companyTarget.querySelectorAll("input").forEach(input => { input.required = company })
  }
}
